import React, { createContext, useContext } from 'react';

const HelpShowcaseContext = createContext(null);

export function HelpShowcaseProvider({ children, openHelpShowcase }) {
  return (
    <HelpShowcaseContext.Provider value={openHelpShowcase}>
      {children}
    </HelpShowcaseContext.Provider>
  );
}

export function useHelpShowcase() {
  return useContext(HelpShowcaseContext);
}
